<template>
  <b-table :data="config.items" :selected.sync="appData.selectedItem" @select="onClick" class="list">
    <template slot-scope="props">
      <b-table-column
        :sortable="true"
        field="name"
        :label="'APP.COLUMNLABELNAME' | eLocales">
        <template v-if="props.row.match.name">
          <span v-html="props.row.match.name"></span>
        </template>
        <template v-else>{{ props.row.name }}</template>
      </b-table-column>
      <b-table-column :sortable="true" field="hit" :label="'APP.COLUMNLABELHIT' | eLocales">{{
        props.row.match.hit
      }}</b-table-column>
      <b-table-column :sortable="true" field="ext" :label="'APP.COLUMNLABELEXT' | eLocales">{{
        props.row.ext
      }}</b-table-column>
    </template>
  </b-table>
</template>
<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'List',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  inject: ['appData'],
  data() {
    return {};
  },
  methods: {
    onClick(item) {
      this.$emit('itemselect', item);
    }
  }
};
</script>
